var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "close (8)") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-332.000000, -59.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(332.000000, 59.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.781405276,16 C0.465379251,16 0.180445024,15.8097133 0.0594991271,15.5177436 C-0.0614467698,15.2257738 0.00542103802,14.889695 0.228914652,14.6662579 L14.6661696,0.22885151 C14.9713018,-0.0762838366 15.4660187,-0.0762838366 15.7711509,0.22885151 C16.076283,0.533986856 16.076283,1.028709 15.7711509,1.33384435 L1.3338959,15.7712508 C1.18749243,15.9179581 0.988664774,16.0002791 0.781405276,16 L0.781405276,16 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2185947,16 C15.0113352,16.0002791 14.8125076,15.9179581 14.6661041,15.7712508 L0.22884911,1.33384435 C-0.0762830365,1.028709 -0.0762830365,0.533986856 0.22884911,0.22885151 C0.533981256,-0.0762838366 1.02869821,-0.0762838366 1.33383036,0.22885151 L15.7710853,14.6662579 C15.994579,14.889695 16.0614468,15.2257738 15.9405009,15.5177436 C15.819555,15.8097133 15.5346207,16 15.2185947,16 L15.2185947,16 Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.d9913ec0.svg";
export { ForwardRef as ReactComponent };